// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IntlTranslations<T = any> = {
  [K in keyof T]: IntlTranslationData | IntlTranslations<T[K]>;
};

export interface IntlTranslationData {
  id: string;
  defaultMessage: string;
}

export const createTranslations = <
  T extends IntlTranslations<T> | IntlTranslations,
>(
  translations: T & IntlTranslations,
): T => {
  return translations;
};
